import React from 'react';
import TimoAdvantages from "../components/TimoAdvantages";
import BlogSection from "../components/BlogSection";
import CallToAction from "../components/CallToAction";



const About = () => {
    return (
        <main className="font-Inter pt-[72px] lg:pt-[109px]">

            <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
                <div className="flex flex-col items-center justify-between lg:flex-row">
                    <div className="mb-10 lg:max-w-lg lg:pr-5 lg:mb-0">
                        <div className="max-w-xl ">
                            <div>
                            </div>
                            <h2 className="max-w-lg mb-6 text-3xl font-semibold tracking-tight text-indigo-800 sm:text-4xl sm:leading-[2.8rem]">
                                Với Timo, thương hiệu của bạn không chỉ "may đẹp" mà còn "thành công lớn"

                            </h2>
                            <p className="text-base text-gray-700 font-OpenSans font-medium md:text-base tracking-tight">
                                Một sản phẩm đẹp thôi chưa đủ, mà còn phải giúp thương hiệu của bạn nổi bật và thành công. Tại Timo, chúng tôi không chỉ cung cấp vải chất lượng, mà còn mang đến giải pháp tối ưu để bạn biến ý tưởng thành sản phẩm ấn tượng.
                            </p>
                            <p className="text-base text-gray-700 font-OpenSans font-medium md:text-base tracking-tight mt-4">
                                Với kinh nghiệm và sự am hiểu sâu sắc về ngành, chúng tôi giúp bạn chọn lựa chất liệu phù hợp, nâng tầm thiết kế và tạo ra những bộ sưu tập không chỉ đẹp mắt mà còn có giá trị thương hiệu. Cùng Timo, bạn không chỉ “may đẹp” mà còn “thành công lớn” trên thị trường."
                            </p>
                        </div>

                    </div>
                    <div className="relative lg:w-1/2">
                        <img
                            className="object-cover w-full h-72 sm:h-[30rem]"
                            src="/assets/images/aboutus/timo3.jpg"
                            alt=""
                        />

                    </div>
                </div>
            </div>
            <TimoAdvantages/>
            <BlogSection/>
            <CallToAction/>
        </main>
    );
};

export default About;